import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NbApiService } from '@service/nb-api.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { API } from '@service/api';
import { ShowyePageAuthService } from '@showye/showye-page-base';

@Component({
  selector: 'app-positive-info',
  templateUrl: './positive-info.component.html',
  styleUrls: ['./info.scss'],
})
export class PositiveInfoComponent implements OnInit {
  @Input() isVisible = true;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Input() detailInfo: any;
  info: any;
  filePath: any;
  token = this.auth.token;

  get value(): any {
    return this.isVisible;
  }

  set value(v: any) {
    this.isVisible = v;
    this.isVisibleChange.emit(v);
  }

  statusEnums: any = {
    pending: { label: '审核中', color: 'red' },
    accepted: { label: '已完成', color: 'green' },
    rejected: { label: '已驳回', color: 'orange' },
    cancelled: { label: '已撤销', color: 'default' },
  };

  constructor(
    private api: NbApiService,
    modalSrv: NzModalService,
    private router: Router,
    private route: ActivatedRoute,
    public msg: NzMessageService,
    public notify: NzNotificationService,
    private apiUrl: API,
    private modal: NzModalService,
    private auth: ShowyePageAuthService,
  ) {}

  ngOnInit(): void {
    this.getPositiveDetail(this.detailInfo.id);
  }

  // 获取转正详情
  getPositiveDetail(id: any): void {
    if (id) {
      this.api.getPositiveDetail(id).subscribe((e: any) => {
        this.info = e.data;
      });
    }
  }

  close(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }

  onDownloadPrint(type?: any): void {
    if (type === 2) {
      window.open(this.apiUrl.POSITIVE_DETAIL_PRINT(this.detailInfo.id, type) + '&token=' + this.token, '_blank');
    } else {
      window.location.href = this.apiUrl.POSITIVE_DETAIL_PRINT(this.detailInfo.id, type) + '&token=' + this.token;
    }
  }

  onDownloadFile(data: any): void {
    if (data.path) {
      this.filePath = data.path;
    }
  }

  fileVisibleChange(ev: boolean): void {
    this.filePath = '';
  }
}
